import { Role } from '~/types/users'
import { getUserRoles } from '~/utils/token'

export function userHasRole(roles: Role[] | Role, ...rest: Role[]): boolean {
  const userRoles = getUserRoles()
  const checkRoles = Array.isArray(roles) ? roles : [roles, ...rest]
  return userRoles.some((role) => checkRoles.includes(role as Role))
}

export function userHasNoRoles() {
  return !getUserRoles().length
}

export function userHasAdminId() {
  const user = useUserStore()
  return !!user.adminId
}
